import { ObjectElementFactory } from "../ObjectElementFactory";
import { SelectElement } from "./SelectElement";
import { ElementRegistry } from "../ElementRegistry";
/**
 * Select Element Factory
 */
export class SelectElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new SelectElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register factory instance
    ElementRegistry.register('select', new SelectElementFactory());
})();
//# sourceMappingURL=SelectElementFactory.js.map